import { useTranslation } from "react-i18next";

function CompanyIdInput({
  onCompanyIdChange,
  value,
}: {
  onCompanyIdChange: (id: string) => void;
  value: string;
}) {
  const { t } = useTranslation();
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    onCompanyIdChange(event.target.value);
  };

  return (
    <div className="flex flex-col gap-2 w-full items-center max-w-[320px]">
      <label
        htmlFor="companyId"
        className="text-[#0C111D] text-sm font-medium w-full text-start mb-1"
      >
        {t("tmc.companyId")}
      </label>
      <input
        type="text"
        id="companyId"
        value={value}
        onChange={handleChange}
        placeholder={t("tmc.companyIdPlaceholder") || "Enter company ID"}
        className="
          h-10 w-full px-4 py-1
          rounded-[12px]
          border border-gray-300
          focus:outline-none focus:ring-2 focus:ring-yellow-500
          transition
          bg-white
          shadow-sm
          text-base
        "
      />
    </div>
  );
}

export default CompanyIdInput;
